import { Cross2Icon, HamburgerMenuIcon } from '@radix-ui/react-icons';
import { CORPORATE_INFO_URL } from 'common/utils/index.constant';
import NavLink from 'components/v2/modules/about-lp/nav-link';

import AboutLPCtaButton from './cta-button';

interface NavMenuType {
  currentPath?: string;
  onMenuClick?: () => void;
}

const NavMenu = ({ currentPath = '' }: NavMenuType) => {
  const menuItems = [
    { href: '/about/creator', label: 'クリエイター' },
    { href: CORPORATE_INFO_URL, label: '会社概要' },
    {
      href: '/about/careers',
      label: '採用情報',
    },
  ];

  return (
    <div className="flex items-center justify-between">
      {/* Desktop Navigation */}
      <nav className="hidden items-center gap-10 lg:flex">
        {menuItems.map((item) => (
          <NavLink
            key={item.href}
            href={item.href}
            isActive={currentPath === item.href}
            isExternal={item.href.startsWith('http')}
          >
            {item.label}
          </NavLink>
        ))}
      </nav>

      {/* CTA Button */}
      <div className="ml-10 hidden lg:block">
        <AboutLPCtaButton
          text="無料で始める"
          type="green"
          href="/"
          position="header"
        />
      </div>

      {/* Mobile Menu Toggle - Far Right */}
      <div className="relative lg:hidden">
        {/* Hidden checkbox for mobile menu toggle */}
        <input
          type="checkbox"
          id="mobile-menu-toggle"
          className="peer hidden"
        />

        {/* Mobile menu toggle button */}
        <label
          htmlFor="mobile-menu-toggle"
          className="mobile-toggle relative z-50 flex size-10 cursor-pointer items-center justify-center transition-all duration-300"
        >
          <HamburgerMenuIcon className="hamburger-icon absolute size-6 text-gray-600 transition-all duration-300" />
          <Cross2Icon className="close-icon absolute size-6 text-gray-600 opacity-0 transition-all duration-300" />
        </label>

        {/* Mobile Navigation - Full Width */}
        <nav className="invisible fixed left-0 top-20 z-40 w-full scale-95 bg-white opacity-0 shadow-lg transition-all duration-300 peer-checked:visible peer-checked:scale-100 peer-checked:opacity-100">
          <div className="flex flex-col">
            {/* Menu Links */}
            <div>
              {menuItems.map((item, index) => (
                <div
                  key={item.href}
                  className="transition-all duration-500"
                  style={{ transitionDelay: `${index * 50}ms` }}
                >
                  <NavLink
                    href={item.href}
                    isActive={currentPath === item.href}
                    isExternal={item.href.startsWith('http')}
                    className="group flex w-full items-center justify-between border-b border-gray-100 px-6 py-4 text-base font-medium text-gray-700 transition-all duration-200 hover:bg-gray-50 hover:text-gray-900"
                  >
                    <span>{item.label}</span>
                    <svg
                      className="size-5 text-gray-400 transition-all duration-200 group-hover:translate-x-1 group-hover:text-gray-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </NavLink>
                </div>
              ))}
            </div>

            {/* Mobile CTA Button */}
            <div className="p-6">
              <div className="flex justify-center">
                <AboutLPCtaButton
                  text="無料で始める"
                  type="green"
                  href="/"
                  position="header"
                />
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default NavMenu;
